module.exports = __webpack_public_path__ + "assets/img/code6.331178f3.png";